import React, { useState } from "react";
import {
    FaLightbulb,
    FaMap,
    FaMoon,
    FaRoad,
    FaSatellite,
    FaStreetView,
    FaSun,
    FaTree,
    FaWalking
} from "react-icons/fa";
import "./BasemapPanel.css";

function BasemapPanel({ handleMapStyleChange }) {
    const basemaps = [
        { label: "Mapbox Standard", style: "mapbox://styles/amgeosolutions/clyingo6o00yr01pnd4cb0vhe", icon: <FaMap /> },
        { label: "Mapbox Standard Satellite", style: "mapbox://styles/mapbox/standard-satellite", icon: <FaSatellite /> },
        { label: "Mapbox Streets", style: "mapbox://styles/mapbox/streets-v12", icon: <FaRoad /> },
        { label: "Mapbox Outdoors", style: "mapbox://styles/mapbox/outdoors-v12", icon: <FaTree /> },
        { label: "Mapbox Light", style: "mapbox://styles/mapbox/light-v11", icon: <FaLightbulb /> },
        { label: "Mapbox Dark", style: "mapbox://styles/mapbox/dark-v11", icon: <FaMoon /> },
        { label: "Mapbox Satellite", style: "mapbox://styles/mapbox/satellite-v9", icon: <FaSatellite /> },
        { label: "Mapbox Satellite Streets", style: "mapbox://styles/mapbox/satellite-streets-v11", icon: <FaStreetView /> },
        { label: "Mapbox Navigation Day", style: "mapbox://styles/mapbox/navigation-day-v1", icon: <FaSun /> },
        { label: "Mapbox Navigation Night", style: "mapbox://styles/mapbox/navigation-night-v1", icon: <FaWalking /> }
    ];

    const defaultStyle = basemaps[0].style;
    const [activeStyle, setActiveStyle] = useState(defaultStyle);

    const handleClick = (style) => {
        const nextStyle =
            activeStyle === style && style !== defaultStyle
                ? defaultStyle
                : style;

        setActiveStyle(nextStyle);
        handleMapStyleChange(nextStyle);
    };

    return (
        <div className="basemap-panel">
            {basemaps.map(({ label, style, icon }) => (
                <button
                    key={label}
                    type="button"
                    className={`basemap-button ${activeStyle === style ? "active" : ""}`}
                    onClick={() => handleClick(style)}
                >
                    <span className="basemap-icon">{icon}</span>

                    <span className="basemap-label">
                        <span>{label}</span>

                        {style === defaultStyle && (
                            <span className="basemap-default-badge">
                                Podrazumijevani
                            </span>
                        )}
                    </span>
                </button>
            ))}
        </div>
    );
}

export default BasemapPanel;